// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__3vAZD","description--center":"Description_description--center__-Z72-","description--spacious":"Description_description--spacious__3M7fm"};